/** Handle the Navigation display logic for the home page
 * Check the home page; get the param and display nav in the home page
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Container
import ContentToggle from './ContentToggle';
import NavDropDown from './NavDropDown';

// Helpers.
import Page from '../../lib/page';

// Home page navigation tab selection
const homeNavUserTab = ['personal', 'business', 'technical'];
const TECHNICAL = 'technical';

class NavHome extends Component {
  // To controll navigation tab by remote config; filter the technical selection
  static userTabs() {
    return homeNavUserTab.filter(tab => !(tab === TECHNICAL && !Page.hasTechnicalTab()));
  }

  render() {
    if (!Page.checkPageInPath(this.props.pathname)) {
      return null;
    }
    return (
      <div className="nav-home-container">
        {Page.isToggleTreatment() ? <ContentToggle userExpClass={NavHome.userTabs()} /> : <NavDropDown />}
      </div>
    );
  }
}

// NavHome Props Types
NavHome.propTypes = {
  pathname: PropTypes.string,
};

// NavHome Props default values
NavHome.defaultProps = {
  pathname: '',
};

// Get the Store data and Pass it as Props.
function mapStateToProps(state) {
  return {
    pathname: state.location.pathname,
  };
}

// export default NavHome;
export default connect(mapStateToProps)(NavHome);
